import axios from "axios";
import {PATHS_API} from "../../../../../../enum";

export const getPurchases = (setPurchasesServices, setPurchasesProducts) => {
    return axios.get(PATHS_API.PURCHASES,{
        withCredentials: true
    })
        .then((data) => {
            const services = [];
            const products = [];

            data.data?.forEach(purchase => {
                // покупку без даних товару пропускаємо, щоб одна зіпсована покупка не ховала весь кошик
                if (!purchase?.product) return;
                // Правильная проверка на тип продукта
                if (purchase.product.type === "priority" || purchase.product.type === "set") {
                    services.push(purchase);
                } else {
                    products.push(purchase);
                }
            });
            setPurchasesServices(services);
            setPurchasesProducts(products);
        })
}
